<ion-header>
  <ion-toolbar #toolbar>
    <ion-buttons slot="start">
      <ion-button appClick (clicked)="onClose()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title><span id="page-title-span">{{ vo.gruppe.Name }}</span></ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="section-content" #content>
  <div class="section" *ngIf="vo.gruppe.Infotext">
    <div class="gruppe-infotext">
      {{ vo.gruppe.Infotext }}
    </div>

    <!-- <div class="mb-25">
      <div class="adresse">
        <h1>{{ 'Adresse' | translate }}</h1>
        <app-adresse [adresse]="adresse" title="Adresse" [buttonsAnzeigen]="false"></app-adresse>
      </div>
    </div> -->

  </div>

  <div class="section">
    <table class="app-table">
      <tbody>
        <ng-container *ngFor="let item of vo.eintraege">
          <ng-container > <!-- *ngIf="!item.istAusgeblendet || istAusgeblendeteEintraegeAnzeigen" -->
            <tr [class.no-bottom-border]="item.nok" [class.istAusgeblendet]="item.istAusgeblendet">
              <td>{{ item.eintrag.name }}
                <!-- <div *ngIf="item.naechstePruefung" class="naechste-pruefung">Nächste Prüfung: {{item.naechstePruefung}}</div> -->
              </td>
              <td class="buttons">
                <ion-button slot="end" [color]="item.okButtonColor" appClick (clicked)="onAbfahrtskontrollItemChanged($event, item, true)" class="toggle-button">
                  <ion-icon name="checkmark"></ion-icon>
                </ion-button>
                <ion-button slot="end" [color]="item.nokButtonColor" appClick (clicked)="onAbfahrtskontrollItemChanged($event, item, false)" class="toggle-button">
                  <ion-icon name="close"></ion-icon>
                </ion-button>
              </td>
            </tr>

            <tr *ngIf="item.nok && (item.bilderMoeglich || item.anmerkungenMoeglich)">
              <td [attr.colspan]="2">
                <ion-textarea *ngIf="item.anmerkungenMoeglich" [(ngModel)]="item.anmerkungen" [placeholder]="'Fehlerbeschreibung' | translate" autoGrow="true" color="{{ item.anmerkungenPflicht ? 'danger' : ''}}" [class.pflicht]="item.anmerkungenPflicht"></ion-textarea>

                <div *ngIf="item.bilderMoeglich">
                  <div class="fotos-container" *ngIf="item.bilder && item.bilder.length">
                    <ion-img *ngFor="let p of item.bilder" class="bild" src="{{ p.src }}" appClick (clicked)="onBildClicked($event, item, p)"></ion-img>
                  </div>

                  <ion-button color="{{ (item.bilderPflicht && (!item.bilder  || item.bilder.length === 0)) ? 'danger' : 'light' }}" appClick (clicked)="onFotoAufnehmen($event, item)" class="icon-button-with-text button-border" [class.pflicht]="item.bilderPflicht">
                    <ion-icon name="camera"></ion-icon> {{ 'Foto aufnehmen' | translate }}
                  </ion-button>
                </div>
              </td>
            </tr>
          </ng-container>
        </ng-container>
      </tbody>
    </table>
  </div>


  <div class="footer-space"></div>
</ion-content>